import { createRouter, type RouterHistory } from '@tanstack/react-router';

import { ErrorBoundaryFallback } from '@repo/ui/ErrorBoundaryFallback';
import { Flex } from '@repo/ui/Flex';
import { rawString } from './components/Language/Language';
import { routeTree } from './routeTree.gen';
import { clientLogger } from './utils/logger';
import { parseSearch, stringifySearch } from './utils/searchParams';

export const errorBoundaryTitle =
  rawString({ langKey: 'pdx.error.boundary.title' }) ?? '';

export const createAppRouter = (history?: RouterHistory) =>
  createRouter({
    routeTree,
    history,
    parseSearch,
    stringifySearch,
    defaultErrorComponent: ({ error, info: _info }) => {
      const { correlationId } = clientLogger.logError(
        error,
        'Router error boundary',
      );
      const correlationIdStr = rawString({
        langKey: 'pdx.global.correlation_id',
        replacementTokens: { correlation_id: correlationId ?? '' },
      });
      return (
        <Flex alignItems="center" justifyContent="center" padding="p-200">
          <ErrorBoundaryFallback
            metaInfo={correlationIdStr}
            message={error.message}
            title={errorBoundaryTitle}
          />
        </Flex>
      );
    },
    defaultPreload: 'intent',
    scrollRestoration: true,
  });
